export const monthsInYear = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const years = ['2023', '2024', '2025', '2026', '2027', '2028'];

export const storyStatusesOrder: string[] = [
  'IDEATION',
  'DRAFT',
  'ASSIGNED',
  'ACCEPTED',
  'IN_PROGRESS',
  'REVIEW',
  'IN_EDIT',
  'IN_APPROVAL',
  'READY_TO_PUBLISH',
  'TO_PUBLISH',
  'PUBLISHED',
  'DELETED',
  'ARCHIVED',
];

export enum RepeatValue {
  YEARLY = 'YEARLY',
  ONCE_OFF = 'ONCE_OFF',
  EVERY_6_MONTHS = 'EVERY_6_MONTHS',
  QUARTERLY = 'QUARTERLY',
  BI_MONTHLY = 'BI_MONTHLY',
  MONTHLY = 'MONTHLY',
}

export const keyRepeatOptions = [
  { value: RepeatValue.ONCE_OFF, label: 'Once off' },
  // { value: RepeatValue.YEARLY, label: 'Yearly' },
];

export const apmRepeatOptions = [
  { value: RepeatValue.ONCE_OFF, label: 'Once off' },
  { value: RepeatValue.MONTHLY, label: 'Monthly' },
  { value: RepeatValue.BI_MONTHLY, label: 'Bi-monthly' },
  { value: RepeatValue.QUARTERLY, label: 'Quarterly' },
  { value: RepeatValue.EVERY_6_MONTHS, label: 'Half-yearly' },
  // { value: RepeatValue.YEARLY, label: 'Yearly' },
];

export const isMobile = (): boolean => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  )
    return true;
  else return false;
};

export const isIOS = (): boolean => {
  if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) return true;
  else return false;
};

export const isSafari =
  navigator.vendor &&
  navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;

export const linkifyOptions = {
  target: '_blank',
  rel: 'noopener noreferrer',
  className: 'text-blue100 !font-medium underline',
};
